'use strict';

angular.module('ClinicApp').controller('ModalClaimSignup', function($scope, $modalInstance, OCClinicUtil, clinicId, verificationCode) {
  $scope.save = function() {
    OCClinicUtil.claimClinic(clinicId, verificationCode).then(function() {
      $modalInstance.close();
    });
  };

});
